import { render, staticRenderFns } from "./ReceivingScanList.vue?vue&type=template&id=2e6bd97e&"
import script from "./ReceivingScanList.vue?vue&type=script&lang=js&"
export * from "./ReceivingScanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports